import Vue from "vue";

import _Analytics from "./Analytics";
export const Analytics = Vue.component("analytics", _Analytics);
